/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { ToggleTemplatesQuoteBindingButton_QuoteTemplateFragmentDoc } from './buttons/ToggleQuoteTemplateBindingMenuItem.generated.js';
import { DuplicateTemplateMenuItem_QuoteTemplateFragmentDoc } from '../buttons/DuplicateTemplateMenuItem.generated.js';
import { DeleteTemplateMenuItem_QuoteTemplateFragmentDoc } from '../buttons/DeleteTemplateMenuItem.generated.js';
export type TemplateQuoteTemplateLatestMenu_QuoteTemplateFragment = { __typename: 'QuoteTemplate', id: string, resolvedAsReadModelVersionNumber?: number | null, isBinding: boolean, title: string, owningSystemOrganisationId: string, usedInOtherTemplates: boolean, hasAnyPublishedVersion: boolean, templateSharing?: { __typename: 'TemplateSharing', id: string, latestSharedVersionNumber: number, subscribedToTemplate?: { __typename: 'TemplateSubscription', subscribedVersionNumber: number } | null } | null };

export const TemplateQuoteTemplateLatestMenu_QuoteTemplateFragmentDoc = gql`
    fragment TemplateQuoteTemplateLatestMenu_QuoteTemplate on QuoteTemplate {
  id
  resolvedAsReadModelVersionNumber
  ...ToggleTemplatesQuoteBindingButton_QuoteTemplate
  ...DuplicateTemplateMenuItem_QuoteTemplate
  ...DeleteTemplateMenuItem_QuoteTemplate
}
    ${ToggleTemplatesQuoteBindingButton_QuoteTemplateFragmentDoc}
${DuplicateTemplateMenuItem_QuoteTemplateFragmentDoc}
${DeleteTemplateMenuItem_QuoteTemplateFragmentDoc}`;